export default __webpack_public_path__ + "static/media/formulario-icon.575f34ea.svg";